<script lang="ts" setup>
import { RangeCalendarCellTrigger, type RangeCalendarCellTriggerProps, useForwardProps } from 'radix-vue'
import { computed, type HTMLAttributes } from 'vue'
import { buttonVariants } from '@/foundation/button'
import { cn } from '@/foundation/utils'

const props = defineProps<RangeCalendarCellTriggerProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <RangeCalendarCellTrigger
    :class="
      cn(
        buttonVariants({ variant: 'ghost' }),
        'h-9 w-9 p-0 font-normal data-[selected]:opacity-100',
        '[&[data-today]:not([data-selected])]:bg-[#F4F4F5] [&[data-today]:not([data-selected])]:rounded-full [&[data-today]:not([data-selected])]:text-[#074880]',
        // Selection Start
        'data-[selection-start]:bg-[#074880] data-[selection-start]:text-white data-[selection-start]:hover:bg-[#074880] data-[selection-start]:hover:text-white data-[selection-start]:focus:bg-[#074880] data-[selection-start]:focus:text-white',
        // Selection End
        'data-[selection-end]:bg-[#074880] data-[selection-end]:text-white data-[selection-end]:hover:bg-[#074880] data-[selection-end]:hover:text-white data-[selection-end]:focus:bg-[#074880] data-[selection-end]:focus:text-white',
        // Outside months
        'data-[outside-view]:text-muted-foreground data-[outside-view]:opacity-50 [&[data-outside-view][data-selected]]:bg-accent/50 [&[data-outside-view][data-selected]]:text-muted-foreground [&[data-outside-view][data-selected]]:opacity-30',
        // Disabled
        'data-[disabled]:text-muted-foreground data-[disabled]:opacity-50',
        // Unavailable
        'data-[unavailable]:text-destructive-foreground data-[unavailable]:line-through',
        props.class,
      )
    "
    v-bind="forwardedProps"
  >
    <slot />
  </RangeCalendarCellTrigger>
</template>
